import type {
  AccountPracInfoResponseDto,
  AccountPracInfoType,
} from '../../types/api';

export const ACCOUNT_TAB_CACHE_KEYS = {
  subscription: 'account/subscription',
  accountSettings: 'account/account-settings',
  assessmentOptions: 'account/assessment-options',
  touchpoints: 'account/touchpoints',
  manageTeam: 'account/manage-team',
} as const;

export interface AccountSharedSnapshotCache {
  accountId: string;
  types: AccountPracInfoType[];
  data: AccountPracInfoResponseDto | null;
  refreshedAt: string | null;
  error: string | null;
}

export interface AccountTabCacheState {
  snapshot: AccountSharedSnapshotCache;
}
